<template>
	<div class="flex flex-col h-screen w-screen overflow-hidden">
		<MaintenancePanel ref="maintenancePanel" compact :show-if-status="['warning','in_progress']"/>

		<div class="flex flex-grow w-full min-h-0">
			<DashboardSidebar />

			<div class="flex flex-1 flex-col min-w-0">
				<DashboardHeader @contactUsClicked="showContactUs = true"/>

				<main class="flex-grow p-6 overflow-y-auto min-h-0">
					<p class="admin-center-title mb-6">Admin Center</p>

					<div class="p-6 rounded-xl bg-neutral border border-neutral-subtle card-shadow">
						<slot></slot>
					</div>
				</main>
			</div>
		</div>
	</div>

	<Teleport to="html">
		<AddOrganizationModal :show="orgStore.getShowAddModal" />
	</Teleport>

	<Teleport to="html">
		<ContactUsModal v-if="showContactUs" :show="showContactUs" :horizontal-alignment="ModalHorizontalAlignment.End" :vertical-alignment="ModalVerticalAlignment.Bottom" @dismiss="showContactUs = false" />
	</Teleport>

	<!-- Alert shown when user loses authentication -->
	<Teleport to="html">
		<MultiButtonModal
			:show="authStore.unAuthenticated"
			icon="alert"
			title="Session Timeout"
			message="Your session has expired. Please sign in again."
			:buttons="[
									new ModalButtonData(
										'Ok', () => { authStore.logout(true) }, ButtonType.Default, ButtonSize.Small
									)
								]"
		/>
	</Teleport>

	<Teleport to="html">
		<SessionTimeoutModal/>
	</Teleport>
</template>

<script setup lang="js">
import DashboardSidebar from '@/components/Dashboard/Sidebar/DashboardSidebar.vue'
import DashboardHeader from '@/components/Dashboard/Header/DashboardHeader.vue'
import AddOrganizationModal from '@/views/Organizations/AddOrganizationModal.vue'

import { useAuthStore } from '@/stores/authStore.js'
import ContactUsModal from '@/views/Contact/ContactUsModal.vue'
import { onBeforeMount, ref } from 'vue'
import { useOrganizationStore } from '@/stores/organizationStore.js'
import { Banner } from '@/models/utils/Toaster.js'
import MultiButtonModal from '@/components/Alerts/MultiButtonModal.vue'
import { ModalButtonData } from '@/components/Alerts/ModalButtonData.js'
import { ButtonSize, ButtonType } from '@/components/Forms/Buttons/SubmitButtonConstants.js'
import { ModalHorizontalAlignment, ModalVerticalAlignment } from '@/components/Alerts/ModalAlignment.js'
import SessionTimeoutModal from '@/components/Modals/SessionTimeoutModal.vue'
import MaintenancePanel from '@/components/Misc/MaintenancePanel.vue'

const banner = new Banner();

const orgStore = useOrganizationStore()
const authStore = useAuthStore()
const showContactUs = ref(false)

onBeforeMount(() => {
	banner.clear()
})
</script>

<style scoped>

.card-shadow {
	box-shadow: 0 8px 13px -3px rgba(0, 0, 0, 0.07);
}

</style>
